var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParentAssignEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8189 3.86523H4.73754C4.27671 3.86523 3.83476 4.0483 3.50891 4.37415C3.18306 4.7 3 5.14195 3 5.60277V17.7655C3 18.2263 3.18306 18.6683 3.50891 18.9941C3.83476 19.32 4.27671 19.5031 4.73754 19.5031H16.9003C17.3611 19.5031 17.8031 19.32 18.1289 18.9941C18.4548 18.6683 18.6378 18.2263 18.6378 17.7655V11.6841",
    stroke: "#919EAB",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3572 3.53978C16.7028 3.19417 17.1716 3 17.6604 3C18.1491 3 18.6179 3.19417 18.9635 3.53978C19.3091 3.8854 19.5033 4.35416 19.5033 4.84294C19.5033 5.33171 19.3091 5.80047 18.9635 6.14609L10.8188 14.2908L7.34375 15.1596L8.21252 11.6845L16.3572 3.53978Z",
    stroke: "#919EAB",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParentAssignEdit);
export default __webpack_public_path__ + "static/media/parent-assign-edit.2157c19f37cdaa579420d1f7db06f498.svg";
export { ForwardRef as ReactComponent };